import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/bovenlokaliteitperdossier/";

const BovenLokaliteitPerDossierApi = {
	get(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(bovenLokaliteit) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(serviceUrl, bovenLokaliteit, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default BovenLokaliteitPerDossierApi;
